import React from 'react'
import SvgIcon, { SvgIconProps } from '@material-ui/core/SvgIcon'

import { ReactComponent as NbQrCodeSvg } from '~/assets/images/icons/nb-qrcode.svg'

export function NbQrCodeIcon(props: SvgIconProps): JSX.Element {
	return (
		<SvgIcon {...props}>
			<NbQrCodeSvg />
		</SvgIcon>
	)
}


export function NbFacebookMessenger(props: SvgIconProps): JSX.Element {
	return (
		<SvgIcon {...props}>
			<NbQrCodeSvg />
		</SvgIcon>
	)
}

